export const COLLECTION_NAME = {
  USER_GEN_ASSETS: "userGenAssets",
  TEST_GEN_ASSETS:"testUserGen",
  ASSETS: "assets",
  PIPELINE: "Pipeline",
  REQUESTS: "requests",
  USER_IMAGE: "userImage",
};